import { FC, ReactNode } from "react"

import Tooltip, { ITooltipProps } from "components/Tooltip/Tooltip"
import Button from "components/Button/Button"

export interface IButtonLinkTooltipProps {
    label: ReactNode
    tooltipProps: Omit<ITooltipProps, "children">
}

const ButtonLinkTooltip: FC<IButtonLinkTooltipProps> = ({
    label,
    tooltipProps,
}) => {
    return (
        <div className="d-inline-block">
            <Tooltip
                {...tooltipProps}>
                <Button
                    theme="link"
                    data-testid="tooltip-link"
                    label={label} />
            </Tooltip>
        </div>
    )
}

export default ButtonLinkTooltip
